/** @format */

import Slider from 'react-slick';
import { Container } from '../../Style/CommonStyle.t3';
import styled from 'styled-components';

export const BlogSliderContainer = styled(Container)`
  width: 100%;
  padding: 2rem 1rem;

  .header_container {
    .heading {
      display: block;
      font-family: 'Tenor Sans', sans-serif;
      font-size: clamp(1.5rem, 1rem + 2vw, 3rem);
      font-weight: bold;
      line-height: 3rem;
      text-align: left;
      color: black;
      margin-top: 2rem;
      margin-bottom: 1rem;

      @media (max-width: 768px) {
        font-size: 2rem;
        line-height: 2.2rem;
        text-align: center;
      }

      @media (max-width: 480px) {
        font-size: 1.6rem;
        line-height: 2rem;
        text-align: center;
      }
    }

    .sub_heading {
      font-family: 'Tenor Sans', sans-serif;
      font-size: 1.125rem;
      font-weight: 300;
      line-height: 1.5rem;
      text-align: left;
      padding-left: 15px;
      color: black;

      @media (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
        padding-left: 0;
      }

      @media (max-width: 480px) {
        font-size: 0.95rem;
        text-align: center;
        padding-left: 0;
      }
    }
  }

  .slick-slide {
    margin: 0 auto;
  }

  .blog_container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 0.5rem;
    }
  }
`;
